<template>
  <v-row>
    <v-col cols="12" md="8" offset-md="2">
      <p v-if="success" class="pa-5">
        {{ $t('changePassword.success') }}
      </p>
      <v-form v-else v-model="valid" class="pa-5" @submit.prevent="changePassword">
        <v-text-field
          v-model="current"
          :rules="rules"
          outlined
          :label="$t('changePassword.current')"
          required
          type="password"
        ></v-text-field>
        <v-text-field
          v-model="new1"
          :rules="rules"
          outlined
          :label="$t('changePassword.new1')"
          required
          type="password"
        ></v-text-field>
        <v-text-field
          v-model="new2"
          :rules="rules"
          outlined
          :label="$t('changePassword.new2')"
          required
          type="password"
        ></v-text-field>
        <v-btn type="submit" class="blue-grey white--text" block>{{ $t('changePassword.button') }}</v-btn>
      </v-form>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import Auth from '@aws-amplify/auth';

export default {
  name: 'LeanChangePassword',
  props: {
    config: Object
  },
  data: () => ({
    valid: false,
    success: false,
    current: '',
    new1: '',
    new2: '',
    rules: [(v) => !!v || 'Required']
  }),
  computed: {
    ...mapState({
      snackbar: (state) => state.snackbar
    })
  },
  methods: {
    ...mapActions('cognito', ['signInUser']),
    ...mapMutations({
      setSnackbar: 'setSnackbar'
    }),
    changePassword() {
      if (this.new1 !== this.new2) {
        this.setSnackbar({
          error: 'error',
          message: this.$t('changePassword.mismatched')
        });
      }
      Auth.currentAuthenticatedUser()
        .then((user) => {
          return Auth.changePassword(user, this.current, this.new1);
        })
        .then((data) => {
          this.setSnackbar({
            message: this.$t('changePassword.success')
          });
          this.current = '';
          this.new1 = '';
          this.new2 = '';
          this.success = true;
        })
        .catch((err) => {
          let msg = '';
          console.log(err);
          if (err.code === 'InvalidParameterException') {
            msg = this.$t('changePassword.notComplexEnough');
          } else if (err.code === 'NotAuthorizedException') {
            msg = this.$t('changePassword.invalidCurrent');
          } else {
            msg = err.message;
          }
          this.setSnackbar({
            error: 'error',
            message: msg
          });
        });
    }
  }
};
</script>
